export function Welcome() {
  return (
    <section className="bg-primary-muted py-16">
      <div className="max-w-4xl mx-auto px-4 text-center">
        {/* Welcome message */}
        <p className="text-xl md:text-2xl text-white mb-12 font-light">
          No matter who you are, or where you are on life's journey, you are welcome here!
        </p>
        
        {/* Pastor and church information */}
        <div className="text-white space-y-6">
          <div className="text-lg md:text-xl font-semibold">
            Pastor Becky Walker
          </div>
          
          <div className="text-lg md:text-xl font-bold">
            PRIDES CORNER COMMUNITY CHURCH
          </div>
          
          <div className="text-base md:text-lg space-y-2">
            <div>235 Pride St.</div>
            <div>Westbrook, Maine 04092</div>
          </div>
          
          <div className="text-sm md:text-base space-y-1 mt-6">
            <div>Office Open: 7:30am to 11:30am Tuesday, Wednesday & Thursday</div>
            <div>Office Phone: 207-797-4636</div>
          </div>
        </div>
      </div>
    </section>
  );
}